<template>
  <div :style="$cmsStyles('c_d253260554b0')" class="container">
    <tools-bar ref="toolsBar"></tools-bar>
    <div class="main-content">
      <div class="service-wrapper">
        <div v-show="$cms('c_d253260554b0', 'f_0001', true)" class="banner-wrapper">
          <h1 class="title">{{ $cms('c_d253260554b0', 'f_0002', "专注家庭健康生活的全球化品牌集团") }}</h1>
          <div class="banner-data-info-list">
            <div class="banner-data-info-item" v-for="(item, index) in bannerDataInfoList" :key="index">
              <div class="num-box">
                <count-to
                  :ref="`count${index}`"
                  :key="index"
                  class="num"
                  separator=""
                  :startVal="0"
                  :endVal="item.num"
                  :duration="1200"
                ></count-to>
                <div class="plus" v-if="item.plus">{{ item.plus }}</div>
              </div>
              <div class="label">{{ item.label }}</div>
            </div>
          </div>
        </div>
        <div class="content-wrapper">
          <div v-show="$cms('c_d253260554b0', 'f_0003', true)" class="box-1">
            <div class="box-header">
              <h2 class="box-header-title">{{ $cms('c_d253260554b0', 'f_0004', "发展历程") }}</h2>
              <div class="box-header-desc">{{ $cms('c_d253260554b0', 'f_0005', "Development History") }}</div>
            </div>
            <div class="sub-info">{{ $cms('c_d253260554b0', 'f_0006', "对标") }}<span>{{ $cms('c_d253260554b0', 'f_0007', "ABG集团") }}</span>{{ $cms('c_d253260554b0', 'f_0008', "和") }}<span>{{ $cms('c_d253260554b0', 'f_0009', "雀巢集团") }}</span>{{ $cms('c_d253260554b0', 'f_0010', "，定位专注家庭健康生活的全球化品牌集团，开启新的10年征程。") }}</div>
            <div class="box-content">
              <div class="item" v-for="(item, index) in infoList" :key="index">
                <div class="info">
                  <div class="info-title" v-html="$cmsHtml(item.title)"></div>
                  <ul class="info-desc">
                    <li v-for="(listItem, listIndex) in item.list" :key="listIndex" v-html="$cmsHtml(listItem)"></li>
                  </ul>
                </div>
                <div class="dot-box">
                  <div class="dot"></div>
                </div>
              </div>
            </div>
          </div>
          <div v-show="$cms('c_d253260554b0', 'f_0011', true)" class="box-2">
            <div class="box-header">
              <h2 class="box-header-title">{{ $cms('c_d253260554b0', 'f_0012', "企业文化") }}</h2>
              <div class="box-header-desc">{{ $cms('c_d253260554b0', 'f_0013', "Corporate Culture") }}</div>
            </div>
            <div class="box-content">
              <div class="item">
                <div class="item-title">{{ $cms('c_d253260554b0', 'f_0014', "愿景") }}</div>
                <img :src="$cms('c_d253260554b0', 'f_0015', &quot;https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250805143133750000137.17543754935491607.png&quot;)" alt="">
                <div class="item-desc">{{ $cms('c_d253260554b0', 'f_0016', "成为全球家庭健康生活的引领者") }}</div>
              </div>
              <div class="item">
                <div class="item-title">{{ $cms('c_d253260554b0', 'f_0017', "使命") }}</div>
                <img :src="$cms('c_d253260554b0', 'f_0018', &quot;https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250805105704650000905.17543626245176420.png&quot;)" alt="">
                <div class="item-desc">{{ $cms('c_d253260554b0', 'f_0019', "让生活变成健康的样子") }}</div>
              </div>
              <div class="item">
                <div class="item-title">{{ $cms('c_d253260554b0', 'f_0020', "价值观") }}</div>
                <img :src="$cms('c_d253260554b0', 'f_0021', &quot;https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250805105704650000238.17543626245175562.png&quot;)" alt="">
                <div class="item-desc">{{ $cms('c_d253260554b0', 'f_0022', "客户至上 正直诚信 敬业专业") }}<br />{{ $cms('c_d253260554b0', 'f_0023', "团队合作 有效有果 冠军意识") }}</div>
              </div>
            </div>
          </div>
          <div v-show="$cms('c_d253260554b0', 'f_0024', true)" class="box-3">
            <div class="box-header">
              <h2 class="box-header-title">{{ $cms('c_d253260554b0', 'f_0025', "创始人介绍") }}</h2>
              <div class="box-header-desc">{{ $cms('c_d253260554b0', 'f_0026', "Founder's Introduction") }}</div>
            </div>
            <div class="box-content">
              <div class="ceo-box">
                <img class="avatar" :src="$cms('c_d253260554b0', 'f_0027', &quot;https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250815111547540000808.17552277472758657.jpg?x-oss-process=image/quality,Q_80&quot;)" alt="">
                <div class="info">
                  <div class="name">{{ $cms('c_d253260554b0', 'f_0028', "王玉林") }}</div>
                  <div class="post">{{ $cms('c_d253260554b0', 'f_0029', "魔筷科技创始人&CEO") }}</div>
                  <div class="desc">{{ $cms('c_d253260554b0', 'f_0030', "杭州市余杭区第十二届政协委员；杭州创新创业百佳人才；杭州余杭区十佳优秀青年；国内首批淘客站长，原阿里巴巴技术专家；2008年创办淘客网站；2015年创办魔筷科技，现任魔筷科技CEO，在流量运营和技术AI领域有较深实践经验。") }}</div>
                </div>
              </div>
              <!-- <div class="partner-list">
                <div class="partner-item" v-for="(item, index) in partnerList" :key="index">
                  <img class="avatar" :src="item.image" alt="">
                  <div class="info">
                    <div class="name">{{ item.name }}</div>
                    <div class="post">{{ item.post }}</div>
                    <div class="desc">{{ item.desc }}</div>
                  </div>
                </div>
              </div>
              <div class="partner-list">
                <div class="partner-item" v-for="(item, index) in subPartnerList" :key="index">
                  <img class="avatar" :src="item.image" alt="">
                  <div class="info">
                    <div class="name">{{ item.name }}</div>
                    <div class="post">{{ item.post }}</div>
                    <div class="desc">{{ item.desc }}</div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ToolsBar from '@/components/ToolsBar.vue'
import CountTo from "vue-count-to";

export default {
  components: {
    ToolsBar,
    CountTo,
  },
  head() { return this.$cmsHead('c_d253260554b0', {
    title: '关于我们-专注家庭健康生活的全球化品牌集团|企业文化|王玉林|魔筷科技',
    meta: [
      {
        name: 'Keywords',
        content:
          '关于我们,魔筷科技,全球化品牌集团,家庭健康生活,企业文化,发展历程,品牌集团,健康生活,快手,抖音,视频号,小红书',
      },
      {
        name: 'Description',
        content:
          '魔筷科技是专注家庭健康生活的全球化品牌集团，致力于为全球消费者提供优质的健康生活产品与服务。了解我们的发展历程、企业文化和品牌理念，共同探索健康生活的无限可能。',
      },
    ],
  }); },

  data() {
    return {
      bannerDataInfoList: this.$cms('c_d253260554b0', 'f_0031', [{"num":30,"plus":"+","label":"战略合作品牌"},{"num":7,"plus":"+","label":"自营品牌"},{"num":5,"plus":"+","label":"自有工厂"},{"num":20,"plus":"+","label":"全国布局云仓"},{"num":700000,"plus":"+","label":"线上动销达人数"},{"num":50000,"plus":"+","label":"线下入驻门店"},{"num":10000000,"plus":"+","label":"累计服务家庭"}]),
      infoList: this.$cms('c_d253260554b0', 'f_0032', [{"title":"魔筷科技正式成立","list":["• 从大型电商系统服务商起航","• 获得来自十八罗汉的天使投资"]},{"title":"电商系统得到大客户认可","list":["• 电商系统服务初见成效， 已服务<br />屈臣氏、世纪联华、杭州大厦等客户","• 获得道生资本千万级Pre-A轮融资"]},{"title":"魔筷微商城上线","list":["• 推出行业首个支撑海量并发的<br />电商SaaS系统魔筷微商城"]},{"title":"魔筷小店上线并获快手战投","list":["• 获得快手投资，上线魔筷小店接入<br />快手平台","• 同年获得唯品会投资"]},{"title":"魔筷小店达成跨平台百亿交易","list":["• 魔筷小店年交易额成功突破100亿","• 打通快手、微信、QQ等多个流量平台","• 获腾讯、钟鼎B轮投资"]},{"title":"魔筷星选网红选货平台上线","list":["• 上线魔筷星选网红选货平台，正式开启供应链业务，成为全网网红首选选货平台","• 获得高榕、五源等多家机构数亿元<br />C轮投资"]},{"title":"升级为品牌集团并购扩张","list":["• 正式升级为品牌集团，孵化收购<br />合味芳、大嘴鳄、可立克等多个消费<br />品牌","• 布局MCN业务，成功签约100多位<br />记录家庭生活主播"]},{"title":"构建主播分发网络核心壁垒","list":["• 自营品牌单月GMV破亿","• 构建了70万+中小主播分发网络，成为行业内唯数不多可以调动海量主播营销<br />资源的公司"]},{"title":"全球化品牌收购落地","list":["• 成立海外品牌集团","• 收购美国大健康品牌DiaryLuck、<br />家居品牌Freshine"]},{"title":"产研销全链路自主闭环","list":["• 布局产研销一体化，构建自有产业链，收购新建5家工厂+3所实验室","• 正式布局线下渠道，自营品牌入驻<br />各大商超"]}]),
      partnerList: this.$cms('c_d253260554b0', 'f_0033', [{"image":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250829165000500000305.17564573991354746.jpeg","name":"VP鲍文焕","post":"魔筷科技副总裁","desc":"花名小鲍，数个亿级品牌操盘手，2020年加入魔筷科技，现任魔筷科技副总裁"},{"image":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250815111547540000726.17552277472769330.jpg","name":"VP杨丹红","post":"魔筷科技副总裁","desc":"曾任鲁班软件销售经理、渠道大区经理、杭州分公司总经理；支付宝KA业务发展经理；合言信息创始人兼总经理。2020年加入魔筷科技，现任魔筷科技副总裁"}]),
      subPartnerList: this.$cms('c_d253260554b0', 'f_0034', [{"image":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250815111547540000226.17552277472734283.jpg?x-oss-process=image/quality,Q_80","name":"曾章强","post":"魔筷科技联合创始人，历任CTO","desc":"原阿里巴巴技术专家，曾供职于淘宝、阿里云，负责淘宝多媒体平台、淘宝CRM平台、图片空间和阿里云RDS平台等多个大型系统的设计与研发工作,2015年联合创办魔筷科技"},{"image":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250815111547540000445.17552277472697171.jpg?x-oss-process=image/quality,Q_80","name":"黄冬林","post":"魔筷科技联合创始人","desc":"曾任淘宝无线事业部高级项目经理，负责客服系统、手机淘宝等产品研发；原唯一优品项目经理；2015年联合创办魔筷科技"},{"image":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250825110915980000827.17560913556125257.jpeg?x-oss-process=image/quality,Q_80","name":"薛元昊","post":"魔筷科技合伙人、副总裁","desc":"浙江大学管理学博士。曾任职于软银中国、城云中国。2019年加入魔筷科技"}])
    }
  },
  mounted() {
    // this.initFullpage()
    this.$refs.toolsBar.show()
  },
  methods: {

  },
}
</script>

<style lang="less" scoped>
@import "../style/common.less";

.main-content {
  padding-top: 90px;
}

.service-wrapper {
  .banner-wrapper {
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    .pxToVw(height, 680);
    background-color: #00092a;
    background-image: var(--cms-c_d253260554b0-f_0035, url("https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250805101250300000275.17543599701789831.jpg?x-oss-process=image/quality,Q_80"));
    background-size: cover;
    background-repeat: no-repeat;
    h1.title {
      .pxToVw(margin-bottom, 13);
      line-height: 1.4;
      .pxToVw(font-size, 60);
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #fff;
    }

    .banner-data-info-list {
      .pxToVw(margin-top, 170);
      display: flex;
      align-items: center;
      justify-content: center;
      .pxToVw(gap, 65);
      .banner-data-info-item {
        color: #FFF;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .num-box {
          .pxToVw(line-height, 68);
          .pxToVw(font-size, 60);
          
          display: flex;
          align-items: center;
          justify-content: center;
          .num {
            font-family: DINCond-Light, DINCond;
            font-style: normal;
            font-weight: 300;
          }
        }
        .plus {
          line-height: 1.4;
          .pxToVw(font-size, 20);
          font-family: PingFangSC, PingFang SC;
          font-weight: 100;
        }
        .label {
          .pxToVw(line-height, 25);
          .pxToVw(font-size, 18);
          font-weight: 300;
        }
        &:nth-child(1) {
          .pxToVw(width, 118);
        }
        &:nth-child(2) {
          .pxToVw(width, 92);
        }
        &:nth-child(3) {
          .pxToVw(width, 92);
        }
        &:nth-child(4) {
          .pxToVw(width, 118);
        }
        &:nth-child(5) {
          .pxToVw(width, 130);
        }
        &:nth-child(6) {
          .pxToVw(width, 140);
        }
        &:nth-child(7) {
          .pxToVw(width, 200);
        }
      }
    }
  }
  .content-wrapper {
    .box-header {
      .pxToVw(padding-top, 80);
      color: #333333;
      &-title {
        margin: 0 auto 8 * @unitVw;
        .pxToVw(margin-bottom, 20);
        text-align: center;
        .pxToVw(line-height, 50);
        .pxToVw(font-size, 36);
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        position: relative;
        &::after {
          content: "";
          position: absolute;
          .pxToVw(top, 58);
          left: 50%;
          .pxToVw(width, 140);
          height: 1px;
          background: #d8d8d8;
          transform: translateX(-50%);
        }
      }
      &-desc {
        text-align: center;
        .pxToVw(line-height, 25);
        .pxToVw(font-size, 18);
        font-weight: 300;
        color: #666;
      }
    }
    .box-1 { 
      .sub-info {
        .pxToVw(width, 900);
        .pxToVw(height, 46);
        .pxToVw(border-radius, 8);
        font-weight: 500;
        .pxToVw(font-size, 20);
        color: #333333;
        .pxToVw(line-height, 28);
        background: #FFF;
        margin: 30px auto 0;
        display: flex;
        align-items: center;
        justify-content: center;
        span {
          color: #FF6600;
        }
      }

      .box-content {
        margin: 0 auto;
        .pxToVw(margin-top, 80);
        .pxToVw(margin-bottom, 80);
        background-image: var(--cms-c_d253260554b0-f_0036, url("https://wdzg-file-online-cdn.mockuai.com/picture/open_file20251117153822490000700.17633651011599906.png"));
        background-size: cover;
        background-repeat: no-repeat;
        .pxToVw(height, 695);
        .pxToVw(width, 1440);
        position: relative;
        
        .dot-box {
          position: absolute;
          .dot {
            .pxToVw(width, 30);
            .pxToVw(height, 30);
            background: #FFFFFF;
            box-shadow: 0px 2px 10px 0px rgba(255,102,0,0.4);
            position: relative;
            .pxToVw(border-radius, 30);
            &::after {
              content: "";
              background: #FF6600;
              position: absolute;
              border-radius: 50%;
              .pxToVw(width, 14);
              .pxToVw(height, 14);
              .pxToVw(top, 8);
              .pxToVw(left, 8);
            }
          }
        }
        .item {
          position: absolute;
          .pxToVw(width, 260);
          .info-title {
            font-weight: 600;
            .pxToVw(font-size, 20);
            color: #FF6600;
            .pxToVw(line-height, 36);
          }
          .info-desc {
            font-weight: 300;
            .pxToVw(font-size, 14);
            color: #666666;
            .pxToVw(line-height, 30);
          }
          &:nth-child(1) {
            .pxToVw(bottom, 350);
            .pxToVw(left, 0);
            .dot-box {
              .pxToVw(bottom, -47);
              .pxToVw(left, 50);
            }
          }
          &:nth-child(2) {
            .pxToVw(top, 392);
            .pxToVw(left, 160);
            .dot-box {
              .pxToVw(top, -30);
              .pxToVw(left, 50);
            }
          }
          &:nth-child(3) {
            .pxToVw(bottom, 354);
            .pxToVw(left, 300);
            .dot-box {
              .pxToVw(bottom, -45);
              .pxToVw(left, 50);
            }
          }
          &:nth-child(4) {
            .pxToVw(top, 383);
            .pxToVw(left, 440);
            .dot-box {
              .pxToVw(top, -38);
              .pxToVw(left, 50);
            }
          }
          &:nth-child(5) {
            .pxToVw(width, 280);
            .pxToVw(bottom, 404);
            .pxToVw(left, 540);
            .dot-box {
              .pxToVw(bottom, -65);
              .pxToVw(left, 90);
            }
          }
          &:nth-child(6) {
            .pxToVw(top, 354); 
            .pxToVw(left, 720);
            .dot-box {
              .pxToVw(top, -60);
              .pxToVw(left, 50);
            }
          }
          &:nth-child(7) {
            .pxToVw(bottom, 485);
            .pxToVw(left, 820);
            .dot-box {
              .pxToVw(bottom, -75);
              .pxToVw(left, 90);
            }
          }
         
          &:nth-child(8) {
            .pxToVw(top, 268);
            .pxToVw(left, 1010);
            .dot-box {
              .pxToVw(top, -70);
              .pxToVw(left, 50);
            }
          }
          &:nth-child(9) {
            .pxToVw(bottom, 608);
            .pxToVw(left, 1100);
            .dot-box {
              .pxToVw(bottom, -75);
              .pxToVw(left, 90);
            }
          }
         
          &:nth-child(10) {
            .pxToVw(top, 96);
            .pxToVw(left, 1310);
            .dot-box {
              .pxToVw(top, -70);
              .pxToVw(left, 50);
            }
          }
        }
      }
    }

    .box-2 {
      background-image: var(--cms-c_d253260554b0-f_0037, url("https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250805175314270000136.17543875940678253.jpg?x-oss-process=image/quality,Q_80"));
      background-size: cover;
      background-repeat: no-repeat;
      .pxToVw(height, 1280);
      .box-header {
        .box-header-title {
          color: #fff;
        }
        .box-header-desc {
          color: #fff;
        }
      }
      .box-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        .pxToVw(margin-top, 60);
        .item {
          display: flex;
          flex-direction: column;
          align-items: center;
          .pxToVw(width, 680);

          &::after {
            content: "";
            width: 100%;
            .pxToVw(height, 1);
            background: #d8d8d8;
          }
          &:last-child {
            &::after {
              display: none;
            }
          }
          .item-title {
            font-weight: 600;
            .pxToVw(font-size, 42);
            color: #FFFFFF;
            .pxToVw(line-height, 59);
            .pxToVw(margin-top, 30);
            position: relative;
            &::after {
              content: "";
              position: absolute;
              .pxToVw(width, 60);
              .pxToVw(height, 4);
              background: #FF6600;
              .pxToVw(bottom, -10);
              left: 50%;
              transform: translateX(-50%);
            }
          }
          .item-desc {
            font-weight: 600;
            .pxToVw(font-size, 32);
            color: #FFFFFF;
            .pxToVw(line-height, 45);
            .pxToVw(margin-bottom, 30);
          }
          img {
            .pxToVw(margin-top, 34);
            display: block;
            .pxToVw(height, 97);
            .pxToVw(margin-bottom, 12);
          }
        }
      }
    }

    .box-3 {
      .box-content {
        .ceo-box {
          display: flex;
          align-items: center;
          justify-content: center;
          .pxToVw(width, 1440);
          margin: 0 auto;
          .pxToVw(margin-top, 60);
          .pxToVw(margin-bottom, 80);
          .avatar {
            .pxToVw(width, 440);
            .pxToVw(height, 600);
            .pxToVw(border-radius, 16);
            object-fit: cover;
            z-index: 1;
          }

          .info {
            display: flex;
            flex-direction: column;
            justify-content: center;
            .pxToVw(width, 1000);
            .pxToVw(height, 426);
            .pxToVw(padding-left, 220);
            background: #FFFFFF;
            box-shadow: 0px 2px 20px 0px rgba(0,0,0,0.09);
            .pxToVw(border-radius, 16);
            .pxToVw(margin-left, -140);
            box-sizing: border-box;
            .name {
              font-weight: 600;
              .pxToVw(font-size, 48);
              .pxToVw(line-height, 36);
              color: #333333;
            }
            .post {
              font-weight: 400;
              .pxToVw(font-size, 28);
              .pxToVw(line-height, 30);
              color: #333333;
              .pxToVw(margin-top, 40);
              .pxToVw(margin-bottom, 40);
            }
            .desc {
              font-weight: 300;
              .pxToVw(font-size, 20);
              .pxToVw(line-height, 40);
              color: #666666;
              .pxToVw(width, 700);
            }
          }
        }

        .partner-list {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          .pxToVw(gap, 60);
          .pxToVw(margin-bottom, 90);
          .partner-item {
            .pxToVw(width, 440);
            .pxToVw(height, 600);
            position: relative;
            .avatar {
              .pxToVw(width, 440);
              .pxToVw(height, 600);
              .pxToVw(border-radius, 16);
              object-fit: cover;
            }
            .info {
              .pxToVw(width, 440);
              position: absolute;
              left: 0;
              bottom: 0;
              color: #FFF;
              box-sizing: border-box;
              .pxToVw(padding-left, 36);
              .pxToVw(padding-right, 36);
              .name {
                font-weight: 600;
                .pxToVw(font-size, 24);
                .pxToVw(line-height, 33);
                
              }
              .post { 
                font-weight: 400;
                .pxToVw(font-size, 18);
                .pxToVw(line-height, 25);
              }
              .desc {   
                font-weight: 300;
                .pxToVw(font-size, 18);
                .pxToVw(line-height, 25);
                .pxToVw(margin-top, 13);
                .pxToVw(margin-bottom, 30);
              }
            }
          }
        }
      }
    }
  }
}
</style>
